import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function TerminosPage() {
  return (
    <div className="min-h-screen bg-black text-white">
      <div className="max-w-4xl mx-auto px-4 py-16">
        {/* Botón volver arriba */}
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-[#E91E8C] hover:underline mb-8"
          onClick={() => window.scrollTo(0, 0)}
        >
          <ArrowLeft size={18} />
          Volver al inicio
        </Link>
        
        <h1 className="text-4xl font-bold mb-8">Términos de Servicio</h1>
        <p className="text-gray-400 mb-8">Última actualización: Septiembre 2026</p>
        
        <div className="space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">1. Aceptación de los Términos</h2>
            <p>Al acceder y utilizar el sitio web de Darkar Company Studios ("el Sitio"), aceptas cumplir con estos Términos de Servicio. Si no estás de acuerdo con alguno de estos términos, te pedimos que no utilices nuestro Sitio.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">2. Uso del Contenido</h2>
            <p>Todo el contenido presente en este Sitio, incluyendo pero no limitado a videos, imágenes, textos, logotipos, y material audiovisual relacionado con "Vete a la Versh", "Pandasaurio" y otras propiedades, es propiedad exclusiva de Darkar Company Studios, LLC o sus licenciantes.</p>
            <p className="mt-4">Queda prohibido:</p>
            <ul className="list-disc list-inside mt-2 space-y-2 ml-4">
              <li>Reproducir, distribuir o modificar el contenido sin autorización expresa</li>
              <li>Usar el contenido con fines comerciales sin licencia</li>
              <li>Descargar o copiar videos para redistribución</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">3. Conducta del Usuario</h2>
            <p>Al utilizar nuestro Sitio, te comprometes a:</p>
            <ul className="list-disc list-inside mt-2 space-y-2 ml-4">
              <li>No realizar actividades que interfieran con el funcionamiento del Sitio</li>
              <li>No intentar acceder a áreas restringidas sin autorización</li>
              <li>Respetar los derechos de propiedad intelectual</li>
              <li>No utilizar el Sitio para actividades ilegales</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">4. Enlaces a Terceros</h2>
            <p>Nuestro Sitio puede contener enlaces a sitios web de terceros (YouTube, Spotify, tiendas en línea, etc.). No somos responsables del contenido ni las prácticas de privacidad de estos sitios externos.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">5. Tienda y Productos</h2>
            <p>Los productos mostrados en nuestra sección de tienda son vendidos a través de plataformas de terceros. Las transacciones, envíos y devoluciones se rigen por los términos de dichas plataformas.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">6. Limitación de Responsabilidad</h2>
            <p>Darkar Company Studios no será responsable por daños directos, indirectos, incidentales o consecuentes que resulten del uso o la imposibilidad de usar el Sitio.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">7. Modificaciones</h2>
            <p>Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios entrarán en vigor inmediatamente después de su publicación en el Sitio.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">8. Contacto</h2>
            <p>Para preguntas sobre estos términos, contáctanos en nuestras redes sociales oficiales o a través de los canales disponibles en el Sitio.</p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[#E91E8C] hover:underline"
            onClick={() => window.scrollTo(0, 0)}
          >
            <ArrowLeft size={18} />
            Volver al inicio
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
